module.exports = __webpack_public_path__ + "img/6.ff0ee519.png";